import React from 'react';
import { Platform, Pressable, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { BlurView } from 'expo-blur';
import { useColorScheme } from 'nativewind';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isMobile, isNative, isWidthBelowMedium } from '../../utils/responsive';
import { cln } from '../../utils/classnames';
import svgIcons from '../../assets';
import Icon from '../Icon';
import { Language } from '../../resources/interfaces';
import { saveLocalStorage } from '../../utils/localStorage';
import client from '../../client/client';
import { useTags } from '../../contexts/Tag/TagContext';
import { useNotifications } from '../../contexts/Notification/NotificationContext';
import { useAuth } from '../../contexts/AuthContext/AuthContext';

const OnboardingNavBar = () => {
  const { i18n } = useTranslation();
  const { fetchTags } = useTags();
  const { fetchNotifications } = useNotifications();
  const { me } = useAuth();
  const navOpacity = Platform.OS === 'android' ? 0.9 : 0.75;
  const { colorScheme } = useColorScheme();
  const insets = useSafeAreaInsets();

  const otherLanguage = i18n.language === Language.hu ? Language.en : Language.hu;

  const handleLanguageChange = async () => {
    i18n.changeLanguage(otherLanguage);
    saveLocalStorage('language', otherLanguage);
    await fetchTags();
    await fetchNotifications();

    if (me?.isOnboarded) {
      client.saveUserLanguage(otherLanguage).catch((error) => {
        // eslint-disable-next-line no-console
        console.error('save user language error:', error);
      });
    }
  };

  return (
    <BlurView
      style={{
        height: isNative ? 72 + insets.top : 80,
        paddingHorizontal: isWidthBelowMedium && isNative ? 12 : 80,
        position: isNative ? 'absolute' : ('fixed' as 'absolute'),
        top: 0,
        backgroundColor:
          colorScheme === 'dark'
            ? `rgba(16,16,16,${navOpacity})`
            : `rgba(246,246,246,${navOpacity})`,
      }}
      intensity={30}
      tint={colorScheme}
      className={cln(
        isMobile ? 'justify-end pb-3' : 'justify-center',
        'w-full z-50 border-neutral-200 dark:border-neutral-930',
      )}
    >
      <View className="flex-row w-full items-center ">
        <View className="flex-1" />
        <Icon
          icon={svgIcons.logo}
          mobileSize={{ width: 113, height: 26 }}
          webSize={{ width: 113, height: 26 }}
        />
        <View className="flex-1 items-end">
          <Pressable
            onPress={handleLanguageChange}
            className={cln('border border-neutral-950 dark:border-neutral-50 p-3 sm:py-2 sm:px-3')}
          >
            <Text className="text-calendarCardTitle font-[sans-400] text-neutral-950 dark:text-neutral-50">
              {otherLanguage.toUpperCase()}
            </Text>
          </Pressable>
        </View>
      </View>
    </BlurView>
  );
};

export default OnboardingNavBar;
